import { render, staticRenderFns } from "./priceformat.vue?vue&type=template&id=3d0c7ff2&"
import script from "./priceformat.vue?vue&type=script&lang=js&"
export * from "./priceformat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d0c7ff2')) {
      api.createRecord('3d0c7ff2', component.options)
    } else {
      api.reload('3d0c7ff2', component.options)
    }
    module.hot.accept("./priceformat.vue?vue&type=template&id=3d0c7ff2&", function () {
      api.rerender('3d0c7ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kSXH04e1mkX3/JS/priceformat.vue"
export default component.exports